import React from 'react';

interface Loading {
  status: 'loading';
  data: Partial<string[][]>;
}

interface Error {
  status: 'error';
  code: number;
  message: string;
}

interface Success {
  status: 'success';
  data: string[][];
}

type ResponseType = Loading | Error | Success;

const useGetRateData = () => {
  const basePath = window.location.pathname.split('/').slice(0, -2).join('/');
  const url = `${basePath}/data/pgip-calculator-pricing-file.csv`;

  const [state, setState] = React.useState<ResponseType>({ status: 'loading', data: [] });
  const csvHeaders = ['Investment', 'Term', 'Product Option', 'Result Type', 'Result'];

  const csvToJson = (csv: string) => {
    const lines = csv.split('\n');
    const headers = lines[0].split(',');
    // Validate headers
    const isValidHeaders = csvHeaders.every(header => headers.includes(header));
    if (!isValidHeaders) {
      console.error('CSV file does not contain the required headers.');
      return [];
    }
    const result = lines.slice(1).map(line => {
      const values = line.match(/"[^"]*"|[^,]+/g);
      const obj: any = {};
      headers.forEach((header, index) => {
        obj[header.trim()] = values?.[index]?.replace(/(^"|"$)/g, '').trim();
      });
      return obj;
    });
    return result;
  };

  const fetchData = async () => {
    setState({ status: 'loading', data: [] });
    try {
      const response = await fetch(url);
      const text = await response.text();
      const parsedData = csvToJson(text);
      if (parsedData.length === 0) {
        setState({ status: 'error', code: 500, message: 'CSV file does not contain the required headers.' });
        return;
      }
      setState({ status: 'success', data: parsedData });
    } catch (err) {
      setState({ status: 'error', code: 500, message: 'Unable to fetch and process CSV file' });
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return state;
};

export default useGetRateData;
